import React from 'react'
import Accordions from "../../../components/Accordions";

const Sem4Ft1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1Xt1ifz_Qc4fH_LbFj-LOFW4sLH3bAyYg/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2024-Batch/FT-1-4-Sem-Curriculum-Syllabus.pdf",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">FT Sem - 4</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem4Ft1